module.exports = __webpack_public_path__ + "media/images/athletes/3568-740274239bc369a94d152ff7ae9a768e.png";